import { ButtonProps } from 'antd';
import { createAsyncSelectors } from '@lib/selectors';
import { ExportButton } from '@ui/general/ExportButton';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import { ComplianceCategory, coreActions } from '@sonar-software/sonar-core';

export const exportStartSelectors = createAsyncSelectors((state) => state.core.dataDictionary.export.post);

export type DataDictionaryExportButtonProps = ButtonProps & {
	applicationId: number | undefined;
	complianceCategory: ComplianceCategory | undefined;
	filters?: string;
	sonarObjectId: number | undefined;
	sonarObjectType: SonarObjectType | undefined;
	tagId: number | undefined;
};

export const DataDictionaryExportButton: React.FC<DataDictionaryExportButtonProps> = ({
	applicationId,
	complianceCategory,
	filters,
	sonarObjectId,
	sonarObjectType,
	tagId,
	...rest
}) => {

	const hasId = sonarObjectId ||
		sonarObjectType ||
		applicationId ||
		tagId ||
		typeof complianceCategory === 'number';

	return (
		<ExportButton
			buttonProps={ {
				id: 'data-dictionary-export-button',
				size: 'large',
				type: 'primary',
				...rest
			} }
			disabled={ Boolean(!hasId) }
			onStartExport={ coreActions.requestPostCoreDataDictionaryExport }
			request={ {
				applicationId: applicationId,
				complianceCategory: complianceCategory,
				filters: filters,
				sonarObjectId: sonarObjectId,
				sonarObjectType: sonarObjectType,
				sortBy: 'name',
				sortDirection: 'Ascending',
				tagId: tagId
			} }
			resetExport={ coreActions.resetPostCoreDataDictionaryExport }
			stateSelector={ exportStartSelectors.state } />
	);
};
